export default __webpack_public_path__ + "static/media/star.e6e59824.svg";